import React, { useState, useEffect, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEqual, debounce } from 'lodash';
import { validate, mergeStyles, GlobalContext } from 'wix-rich-content-common';
import pluginFileUploadSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-file-upload.schema.json';
import Tooltip from 'wix-rich-content-common/libs/Tooltip';
import classnames from 'classnames';

var __defProp$e = Object.defineProperty;
var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
var __hasOwnProp$d = Object.prototype.hasOwnProperty;
var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$d = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$d.call(b, prop))
      __defNormalProp$e(a, prop, b[prop]);
  if (__getOwnPropSymbols$d)
    for (var prop of __getOwnPropSymbols$d(b)) {
      if (__propIsEnum$d.call(b, prop))
        __defNormalProp$e(a, prop, b[prop]);
    }
  return a;
};
const LoaderIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$d({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
  "path",
  {
    id: "file-upload-loader-icon-path",
    d: "M14.064 5.948l1.518-.507A8 8 0 1 1 10.473.39l-.506 1.519a6.4 6.4 0 1 0 4.097 4.04z"
  }
)), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(4 4)" }, /* @__PURE__ */ React.createElement("mask", { id: "file-upload-loader-mask", fill: "currentColor" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#file-upload-loader-icon-path" })), /* @__PURE__ */ React.createElement("use", { fill: "currentColor", xlinkHref: "#file-upload-loader-icon-path" }), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M-4-4h24v24H-4z", mask: "url(#file-upload-loader-mask)" })));

var __defProp$d = Object.defineProperty;
var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
var __hasOwnProp$c = Object.prototype.hasOwnProperty;
var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$c = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$c.call(b, prop))
      __defNormalProp$d(a, prop, b[prop]);
  if (__getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(b)) {
      if (__propIsEnum$c.call(b, prop))
        __defNormalProp$d(a, prop, b[prop]);
    }
  return a;
};
var __objRest$7 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$c.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$c)
    for (var prop of __getOwnPropSymbols$c(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$c.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const xlsIcon = (_a) => {
  var _b = _a, { styles } = _b, rest = __objRest$7(_b, ["styles"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues$c({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42" }, rest), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      d: "M0 0H4823V3877H0z",
      transform: "translate(-1489 -3614)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      d: "M1489 3613H1529V3655H1489z",
      transform: "translate(-1489 -3614)"
    }
  ), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.63 0.89L7.93 8.34 4.88 4.75 0.5 9.89 6.75 9.89 9.25 9.89 20.5 9.89z",
      transform: "translate(-1489 -3614) translate(1492 3613) translate(6 21)"
    }
  ), /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame, strokeLinejoin: "bevel" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M32.5 41.5L0.5 41.5 0.5 0.5 19.95 0.5 32.5 13.31z",
      transform: "translate(-1489 -3614) translate(1492 3613)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.59 13.36L32.5 13.31 31.86 12.68 20.59 1.14 19.95 0.5z",
      transform: "translate(-1489 -3614) translate(1492 3613)"
    }
  )), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      fillRule: "nonzero",
      d: "M3.29 11.55L0.62 11.55 4.16 5.95 0.8 0.55 3.54 0.55 5.5 4.13 7.52 0.55 10.17 0.55 6.81 5.86 10.38 11.55 7.59 11.55 5.5 7.8z",
      transform: "translate(-1489 -3614) translate(1492 3613) translate(11 19)"
    }
  ))));
};

var __defProp$c = Object.defineProperty;
var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
var __hasOwnProp$b = Object.prototype.hasOwnProperty;
var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$b = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$b.call(b, prop))
      __defNormalProp$c(a, prop, b[prop]);
  if (__getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(b)) {
      if (__propIsEnum$b.call(b, prop))
        __defNormalProp$c(a, prop, b[prop]);
    }
  return a;
};
var __objRest$6 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$b.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$b)
    for (var prop of __getOwnPropSymbols$b(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$b.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const vidAudIcon = (_a) => {
  var _b = _a, { styles } = _b, rest = __objRest$6(_b, ["styles"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues$b({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42" }, rest), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FFF",
      fillOpacity: "0.0",
      d: "M0 0H4823V3877H0z",
      transform: "translate(-1625 -3613)"
    }
  ), /* @__PURE__ */ React.createElement("path", { d: "M1625 3612H1665V3654H1625z", transform: "translate(-1625 -3613)" }), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FFF",
      d: "M13.6 0.9L7.9 8.3 4.9 4.7 0.5 9.9 6.7 9.9 9.2 9.9 20.5 9.9z",
      transform: "translate(-1625 -3613) translate(1628 3613) translate(6 21)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FFF",
      fillRule: "nonzero",
      d: "M3.3 11.5L0.6 11.5 4.2 5.9 0.8 0.6 3.5 0.6 5.5 4.1 7.5 0.6 10.2 0.6 6.8 5.9 10.4 11.5 7.6 11.5 5.5 7.8z",
      transform: "translate(-1625 -3613) translate(1628 3613) translate(11 19)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FFF",
      fillRule: "nonzero",
      d: "M18.4 23.2c0-.6-.2-1-.5-1.2-.3-.2-.7-.4-1.3-.4h-2.1v3.2h2.1c.5 0 1-.1 1.3-.4.4-.3.5-.7.5-1.2zm2.3-.1c0 1.3-.3 2.2-1 2.8-.7.5-1.6.8-2.8.8h-2.3v4h-2.3v-11h4.8c1.1 0 2 .3 2.6.9.7.5 1 1.4 1 2.5z",
      transform: "translate(-1625 -3613) translate(1628 3613)"
    }
  ), /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame, strokeLinejoin: "bevel", strokeWidth: "1.003" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M32.5 41.5L0.5 41.5 0.5 0.5 20 0.5 32.5 13.3z",
      transform: "translate(-1625 -3613) translate(1628 3613)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19 13.4L31.9 13.3 31.3 12.7 20 1.1 19.4 0.5z",
      transform: "translate(-1625 -3613) translate(1628 3613)"
    }
  )), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      d: "M10.3 5.8L0.2 10.9 0.2 0.7z",
      transform: "translate(-1625 -3613) translate(1628 3613) translate(12 19)"
    }
  ))));
};

var __defProp$b = Object.defineProperty;
var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
var __hasOwnProp$a = Object.prototype.hasOwnProperty;
var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$a = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$a.call(b, prop))
      __defNormalProp$b(a, prop, b[prop]);
  if (__getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(b)) {
      if (__propIsEnum$a.call(b, prop))
        __defNormalProp$b(a, prop, b[prop]);
    }
  return a;
};
var __objRest$5 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$a.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$a)
    for (var prop of __getOwnPropSymbols$a(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$a.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const pptIcon = (_a) => {
  var _b = _a, { styles } = _b, rest = __objRest$5(_b, ["styles"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues$a({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42" }, rest), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      d: "M0 0H4823V3877H0z",
      transform: "translate(-1535 -3613)"
    }
  ), /* @__PURE__ */ React.createElement("path", { d: "M1535 3613H1575V3655H1535z", transform: "translate(-1535 -3613)" }), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      d: "M13.6 0.9L7.9 8.3 4.9 4.7 0.5 9.9 6.7 9.9 9.2 9.9 20.5 9.9z",
      transform: "translate(-1535 -3613) translate(1535 3613) translate(9 21)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      fillRule: "nonzero",
      d: "M3.3 11.5L0.6 11.5 4.2 5.9 0.8 0.6 3.5 0.6 5.5 4.1 7.5 0.6 10.2 0.6 6.8 5.9 10.4 11.5 7.6 11.5 5.5 7.8z",
      transform: "translate(-1535 -3613) translate(1535 3613) translate(14 19)"
    }
  ), /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame, strokeLinejoin: "bevel", strokeWidth: "1.003" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M35.5 41.5L3.5 41.5 3.5 0.5 23 0.5 35.5 13.3z",
      transform: "translate(-1535 -3613) translate(1535 3613)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M22.6 13.4L35.5 13.3 34.9 12.7 23.6 1.1 23 0.5z",
      transform: "translate(-1535 -3613) translate(1535 3613)"
    }
  )), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      fillRule: "nonzero",
      d: "M21.4 23.2c0-.6-.2-1-.5-1.2-.3-.2-.7-.4-1.3-.4h-2.1v3.2h2.1c.5 0 1-.1 1.3-.4.4-.3.5-.7.5-1.2zm2.3-.1c0 1.3-.3 2.2-1 2.8-.7.5-1.6.8-2.8.8h-2.3v4h-2.3v-11h4.8c1.1 0 2 .3 2.6.9.7.5 1 1.4 1 2.5z",
      transform: "translate(-1535 -3613) translate(1535 3613)"
    }
  ))));
};

var __defProp$a = Object.defineProperty;
var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$9 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$9.call(b, prop))
      __defNormalProp$a(a, prop, b[prop]);
  if (__getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(b)) {
      if (__propIsEnum$9.call(b, prop))
        __defNormalProp$a(a, prop, b[prop]);
    }
  return a;
};
var __objRest$4 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$9.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$9)
    for (var prop of __getOwnPropSymbols$9(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$9.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const pdfIcon = (_a) => {
  var _b = _a, { styles } = _b, rest = __objRest$4(_b, ["styles"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues$9({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42" }, rest), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FFF",
      fillOpacity: "0.0",
      d: "M0 0H4823V3877H0z",
      transform: "translate(-1579 -3613)"
    }
  ), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame, strokeLinejoin: "bevel", strokeWidth: "1.003" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M32.5 41.5L0.5 41.5 0.5 0.5 20 0.5 32.5 13.3z",
      transform: "translate(-1579 -3613) translate(1582 3613)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.6 13.4L32.5 13.3 31.9 12.7 20.6 1.1 20 0.5z",
      transform: "translate(-1579 -3613) translate(1582 3613)"
    }
  )), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      d: "M22.982 27.818s0 .1 0 0c0 .1-.2.2-.6.2h-.3c-.4-.1-1-.4-1.6-.9 1.7.1 2.3.5 2.5.7zm-5-1.7c-.6.1-1.4.2-2.4.4.4-.8.7-1.5 1-2.2.1.1.2.3.3.4.4.4.8.9 1.1 1.4zm-1.9-6.9c.1-.2.2-.3.2-.3.1.1.3.4.2 2 0 .3-.1.6-.2 1-.3-1-.4-2-.2-2.7zm-4.5 11.3c-.2.1-.3.2-.5.2 0-.1.1-.6.8-1.3.4-.3.8-.7 1.3-.9-.6 1-1.2 1.8-1.6 2zm7.8-4.5c-.6-.6-1.1-1.4-1.7-2l-.6-.9c.3-.9.5-1.6.5-2.2.1-1.4-.1-2.3-.5-2.8-.3-.3-.7-.4-1.1-.2-.3.1-.7.3-.9 1-.4 1-.2 2.9.7 4.4-.4 1.1-1 2.4-1.6 3.6-1.3.4-2.3 1-3 1.7-.9.9-1.3 1.8-1 2.5.1.5.5.7 1 .7.3 0 .7-.1 1.1-.4.9-.6 2-2.5 2.7-3.6 1.2-.4 2.5-.6 3.1-.6.3 0 .6-.1.9-.1 1.1 1.2 2.1 1.8 2.9 2h.5c.7 0 1.3-.3 1.5-.7.2-.4.2-.8 0-1.1-.5-.8-1.9-1.3-4-1.3h-.5z",
      transform: "translate(-1579 -3613) translate(1582 3613)"
    }
  ))));
};

var __defProp$9 = Object.defineProperty;
var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$8 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$8.call(b, prop))
      __defNormalProp$9(a, prop, b[prop]);
  if (__getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(b)) {
      if (__propIsEnum$8.call(b, prop))
        __defNormalProp$9(a, prop, b[prop]);
    }
  return a;
};
var __objRest$3 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$8.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$8)
    for (var prop of __getOwnPropSymbols$8(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$8.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const otherIcon = (_a) => {
  var _b = _a, { styles } = _b, rest = __objRest$3(_b, ["styles"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues$8({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42" }, rest), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      d: "M0 0H4823V3877H0z",
      transform: "translate(-1717 -3612)"
    }
  ), /* @__PURE__ */ React.createElement("path", { d: "M1717 3612H1757V3654H1717z", transform: "translate(-1717 -3612)" }), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      d: "M13.6 0.9L7.9 8.3 4.9 4.7 0.5 9.9 6.7 9.9 9.2 9.9 20.5 9.9z",
      transform: "translate(-1717 -3612) translate(1720 3613) translate(6 21)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      fillRule: "nonzero",
      d: "M3.3 11.5L0.6 11.5 4.2 5.9 0.8 0.6 3.5 0.6 5.5 4.1 7.5 0.6 10.2 0.6 6.8 5.9 10.4 11.5 7.6 11.5 5.5 7.8z",
      transform: "translate(-1717 -3612) translate(1720 3613) translate(11 19)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      fillRule: "nonzero",
      d: "M18.4 23.2c0-.6-.2-1-.5-1.2-.3-.2-.7-.4-1.3-.4h-2.1v3.2h2.1c.5 0 1-.1 1.3-.4.4-.3.5-.7.5-1.2zm2.3-.1c0 1.3-.3 2.2-1 2.8-.7.5-1.6.8-2.8.8h-2.3v4h-2.3v-11h4.8c1.1 0 2 .3 2.6.9.7.5 1 1.4 1 2.5z",
      transform: "translate(-1717 -3612) translate(1720 3613)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      d: "M10.3 5.8L0.2 10.9 0.2 0.7z",
      transform: "translate(-1717 -3612) translate(1720 3613) translate(12 19)"
    }
  ), /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame, strokeLinejoin: "bevel", strokeWidth: "1.003" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M32.5 41.5L0.5 41.5 0.5 0.5 20 0.5 32.5 13.4z",
      transform: "translate(-1717 -3612) translate(1720 3613)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19 13.4L31.9 13.4 31.3 12.7 20 1.2 19.4 0.5z",
      transform: "translate(-1717 -3612) translate(1720 3613)"
    }
  )), /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_background }, /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      d: "M.5 4H10.5V5H.5zM.5 0H10.5V1H.5zM5.5 12L10.5 8 .5 8z",
      transform: "translate(-1717 -3612) translate(1720 3613) translate(10.963 19.09)"
    }
  )))));
};

var __defProp$8 = Object.defineProperty;
var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$7 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$7.call(b, prop))
      __defNormalProp$8(a, prop, b[prop]);
  if (__getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(b)) {
      if (__propIsEnum$7.call(b, prop))
        __defNormalProp$8(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$7)
    for (var prop of __getOwnPropSymbols$7(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const imageIcon = (_a) => {
  var _b = _a, { styles } = _b, rest = __objRest$2(_b, ["styles"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues$7({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42" }, rest), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#FFF",
      fillOpacity: "0.0",
      d: "M0 0H4823V3877H0z",
      transform: "translate(-1671 -3612)"
    }
  ), /* @__PURE__ */ React.createElement("path", { d: "M1671 3612H1711V3654H1671z", transform: "translate(-1671 -3612)" }), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame, strokeLinejoin: "bevel", strokeWidth: "1.003" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M32.5 41.5L0.5 41.5 0.5 0.5 20 0.5 32.5 13.3z",
      transform: "translate(-1671 -3612) translate(1674 3613)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.6 13.4L32.5 13.3 31.9 12.7 20.6 1.1 20 0.5z",
      transform: "translate(-1671 -3612) translate(1674 3613)"
    }
  )), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      d: "M13.6 0.9L7.9 8.3 4.9 4.7 0.5 9.9 6.7 9.9 9.2 9.9 20.5 9.9z",
      transform: "translate(-1671 -3612) translate(1674 3613) translate(6 21)"
    }
  ))));
};

var __defProp$7 = Object.defineProperty;
var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$6 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$6.call(b, prop))
      __defNormalProp$7(a, prop, b[prop]);
  if (__getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(b)) {
      if (__propIsEnum$6.call(b, prop))
        __defNormalProp$7(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$6.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$6)
    for (var prop of __getOwnPropSymbols$6(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$6.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const folderIcon = (_a) => {
  var _b = _a, { styles } = _b, rest = __objRest$1(_b, ["styles"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues$6({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42" }, rest), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      d: "M0 0H4823V3877H0z",
      transform: "translate(-1761 -3612)"
    }
  ), /* @__PURE__ */ React.createElement("path", { d: "M1761 3612H1801V3654H1761z", transform: "translate(-1761 -3612)" }), /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M.716 29.29V1.726c0-.552.448-1 1-1h.003l13.104.039c.307 0 .597.143.786.385l3.812 4.888c.189.243.48.385.788.385h16.072c.552 0 1 .447 1 1V29.29h0H.716z",
      transform: "translate(-1761 -3612) translate(1762 3619)"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M0.656 6.431L20.482 6.431",
      transform: "translate(-1761 -3612) translate(1762 3619)"
    }
  ))));
};

var __defProp$6 = Object.defineProperty;
var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$5 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$5.call(b, prop))
      __defNormalProp$6(a, prop, b[prop]);
  if (__getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(b)) {
      if (__propIsEnum$5.call(b, prop))
        __defNormalProp$6(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$5.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$5)
    for (var prop of __getOwnPropSymbols$5(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$5.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const docIcon = (_a) => {
  var _b = _a, { styles } = _b, rest = __objRest(_b, ["styles"]);
  return /* @__PURE__ */ React.createElement("svg", __spreadValues$5({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42" }, rest), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      d: "M0 0H4823V3877H0z",
      transform: "translate(-1446 -3614)"
    }
  ), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
    "g",
    {
      fill: "currentColor",
      className: styles.file_upload_icon_frame,
      strokeLinejoin: "bevel",
      strokeWidth: "1.003"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M32.5 41.5L0.5 41.5 0.5 0.5 20 0.5 32.5 13.3z",
        transform: "translate(-1446 -3614) translate(1446 3614) translate(3)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "nonzero",
        d: "M19.2 13.4L32.1 13.3 31.5 12.7 20.2 1.1 19.6 0.5z",
        transform: "translate(-1446 -3614) translate(1446 3614) translate(3)"
      }
    )
  ), /* @__PURE__ */ React.createElement("path", { d: "M0 0H40V42H0z", transform: "translate(-1446 -3614) translate(1446 3614)" }), /* @__PURE__ */ React.createElement(
    "path",
    {
      className: styles.file_upload_icon_background,
      fillRule: "nonzero",
      d: "M3.1 0.6L4.6 6.8 4.9 8.6 5.2 6.9 6.5 0.6 8.9 0.6 10.2 6.8 10.5 8.6 10.9 6.9 12.3 0.6 14.7 0.6 11.6 11.5 9.4 11.5 8 5.1 7.7 3 7.3 5.1 5.9 11.5 3.8 11.5 0.7 0.6z",
      transform: "translate(-1446 -3614) translate(1446 3614) translate(12 19)"
    }
  ))));
};

var FileTypes = /* @__PURE__ */ ((FileTypes2) => {
  FileTypes2[FileTypes2["IMAGE"] = 1] = "IMAGE";
  FileTypes2[FileTypes2["VIDEO"] = 2] = "VIDEO";
  FileTypes2[FileTypes2["WORD"] = 3] = "WORD";
  FileTypes2[FileTypes2["EXCEL"] = 4] = "EXCEL";
  FileTypes2[FileTypes2["ARCHIVE"] = 5] = "ARCHIVE";
  FileTypes2[FileTypes2["PDF"] = 6] = "PDF";
  FileTypes2[FileTypes2["POWERPOINT"] = 7] = "POWERPOINT";
  FileTypes2[FileTypes2["AUDIO"] = 8] = "AUDIO";
  FileTypes2[FileTypes2["MISC"] = 9] = "MISC";
  return FileTypes2;
})(FileTypes || {});
const doc = new RegExp("^doc([a-z]*)$");
const excel = new RegExp("^xl([a-z]*)$");
const ppt = new RegExp("^ppt([a-z]*)$");
const images = [
  "jpg",
  "png",
  "gif",
  "jpeg",
  "jpe",
  "jfif",
  "bmp",
  "heic",
  "heif",
  "tfif",
  "tif",
  "webp"
];
const videos = [
  "avi",
  "mpeg",
  "mpg",
  "mpe",
  "mp4",
  "mkv",
  "webm",
  "mov",
  "ogv",
  "vob",
  "m4v",
  "3gp",
  "divx",
  "xvid",
  "mxf",
  "wmv",
  "m1v",
  "flv"
];
const audios = ["mp3", "pcm", "wav", "aiff", "aif", "aac", "ogg", "wma", "m4a", "flac"];
const pdf = ["pdf"];
const folder = ["zip", "rar", "tar", "gz", "gzip", "jar", "7z", "fgz", "webarchive"];
const extRegList = [
  { data: doc, fileType: 3 /* WORD */ },
  { data: excel, fileType: 4 /* EXCEL */ },
  { data: ppt, fileType: 7 /* POWERPOINT */ }
];
const extList = [
  { data: images, fileType: 1 /* IMAGE */ },
  { data: videos, fileType: 2 /* VIDEO */ },
  { data: audios, fileType: 8 /* AUDIO */ },
  { data: pdf, fileType: 6 /* PDF */ },
  { data: folder, fileType: 5 /* ARCHIVE */ }
];
function getFileTypeFromList(extension, checkList, extensionPredicate) {
  let retVal;
  checkList.some(({ data, fileType }) => {
    if (extensionPredicate(data, extension)) {
      retVal = fileType;
      return true;
    }
    return false;
  });
  return retVal;
}
const fileExtensionToType = (extension) => {
  const fileType = extension && (getFileTypeFromList(
    extension,
    extRegList,
    (regExp, extension2) => regExp.test(extension2)
  ) || getFileTypeFromList(
    extension,
    extList,
    (typeList, extension2) => typeList.includes(extension2)
  ));
  return fileType || 9 /* MISC */;
};

const iconMap = {
  [FileTypes.IMAGE]: imageIcon,
  [FileTypes.VIDEO]: vidAudIcon,
  [FileTypes.AUDIO]: vidAudIcon,
  [FileTypes.PDF]: pdfIcon,
  [FileTypes.ARCHIVE]: folderIcon,
  [FileTypes.WORD]: docIcon,
  [FileTypes.EXCEL]: xlsIcon,
  [FileTypes.POWERPOINT]: pptIcon,
  [FileTypes.MISC]: otherIcon
};
const getIcon = (extension) => {
  return iconMap[fileExtensionToType(extension)];
};

var __defProp$5 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
const DownloadIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$4({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.5 20c.276 0 .5.224.5.5s-.224.5-.5.5h-12c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h12zm-6-16c.276 0 .5.224.5.5v11.515l2.197-1.898c.2-.173.503-.151.677.049l.009.01.005.007c.17.21.144.517-.06.694l-2.978 2.574c-.048.042-.103.072-.16.092-.165.089-.375.075-.53-.051l-.01-.009-2.977-2.573c-.205-.177-.231-.485-.06-.694l.005-.007c.167-.205.47-.236.675-.069l.01.01L11 16.047V4.5c0-.276.224-.5.5-.5z"
  }
));

var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
const ErrorIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues$3({ xmlns: "http://www.w3.org/2000/svg", width: "28", height: "28", viewBox: "0 0 28 28" }, props), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "#F64D43" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M9.333 18.148C4.46 18.148.52 14.208.52 9.333.519 4.46 4.459.52 9.333.52c4.874 0 8.815 3.94 8.815 8.814 0 4.874-3.94 8.815-8.815 8.815zm0 0c4.874 0 8.815-3.94 8.815-8.815 0-4.874-3.94-8.814-8.815-8.814C4.46.519.52 4.459.52 9.333c0 4.874 3.94 8.815 8.814 8.815zM9.333 4.148L9.333 11.407M9.333 13.481L9.333 14.519",
    transform: "translate(4.667 4.667)"
  }
)));

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
const ReadyIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues$2({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "filter",
    {
      id: "file_upload_ready_icon_a",
      width: "271.4%",
      height: "340%",
      x: "-85.7%",
      y: "-85.7%",
      filterUnits: "objectBoundingBox"
    },
    /* @__PURE__ */ React.createElement("feOffset", { dy: "4", in: "SourceAlpha", result: "shadowOffsetOuter1" }),
    /* @__PURE__ */ React.createElement("feGaussianBlur", { in: "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "4" }),
    /* @__PURE__ */ React.createElement(
      "feColorMatrix",
      {
        in: "shadowBlurOuter1",
        result: "shadowMatrixOuter1",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      }
    ),
    /* @__PURE__ */ React.createElement("feOffset", { in: "SourceAlpha", result: "shadowOffsetOuter2" }),
    /* @__PURE__ */ React.createElement("feGaussianBlur", { in: "shadowOffsetOuter2", result: "shadowBlurOuter2", stdDeviation: "2" }),
    /* @__PURE__ */ React.createElement(
      "feColorMatrix",
      {
        in: "shadowBlurOuter2",
        result: "shadowMatrixOuter2",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
      }
    ),
    /* @__PURE__ */ React.createElement("feMerge", null, /* @__PURE__ */ React.createElement("feMergeNode", { in: "shadowMatrixOuter1" }), /* @__PURE__ */ React.createElement("feMergeNode", { in: "shadowMatrixOuter2" }))
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "file_upload_ready_icon_b",
      d: "M16.346 0.167L17.167 0.963 6.97 11.833 0.833 6.925 1.534 6.019 6.861 10.279z"
    }
  )),
  /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(3 6)" }, /* @__PURE__ */ React.createElement(
    "use",
    {
      fill: "#000",
      filter: "url(#file_upload_ready_icon_a)",
      xlinkHref: "#file_upload_ready_icon_b"
    }
  ), /* @__PURE__ */ React.createElement("use", { fill: "#008250", xlinkHref: "#file_upload_ready_icon_b" }))
);

var styles$1 = {"fontElementMap":"SSzad","file_upload_container":"l-866","file_upload_error_container":"hkYJK","file_upload_link":"_6svE6","width_three":"y21-C","file_upload_text_container":"rgq3f","width_two":"Xi0J0","file_upload_state":"ar3R5","mobile_status_icon":"OWCG1","file_upload_name_container":"BmvWg","file_upload_name":"qh3rM","file_upload_extension":"NQ5lJ","width_one":"_23MqI","file_upload_type_icon":"jsEyh","file_loader_icon":"ipEJG","spin":"VF7bf","file_upload_type":"_2ytq9","file_upload_text_error":"G501h","file_upload_icon_frame":"JSBEP","file_upload_icon_background":"QDSVO"};

const FILE_UPLOAD_TYPE = "wix-draft-plugin-file-upload";

var __defProp$2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class PDFViewSDKClient {
  constructor(scope) {
    this.window = scope;
    this.readyPromise = new Promise((resolve) => {
      if (this.window.AdobeDC) {
        resolve();
      } else {
        this.window.document.addEventListener("adobe_dc_view_sdk.ready", () => {
          resolve();
        });
      }
    });
  }
  ready() {
    return this.readyPromise;
  }
  previewFileWithURL(config, fileData, viewerConfig) {
    const { url, fileName } = fileData;
    this.adobeDCView = new this.window.AdobeDC.View(config);
    return new Promise((resolve) => {
      this.adobeDCView.previewFile(
        {
          content: {
            location: {
              url
            }
          },
          metaData: {
            fileName
          }
        },
        __spreadProps(__spreadValues$1({}, viewerConfig), {
          showLeftHandPanel: false,
          showAnnotationTools: false,
          enableLinearization: true
        })
      );
      resolve();
    });
  }
  previewFileWithBlob(config, fileData, viewerConfig) {
    const { url, fileName } = fileData;
    return new Promise((resolve, reject) => {
      fetch(new Request(url)).then((response) => response.blob()).then((blob) => {
        this.adobeDCView = new this.window.AdobeDC.View(config);
        this.adobeDCView.previewFile(
          {
            content: {
              promise: Promise.resolve(blob.arrayBuffer())
            },
            metaData: {
              fileName
            }
          },
          __spreadProps(__spreadValues$1({}, viewerConfig), {
            showLeftHandPanel: false,
            showAnnotationTools: false
            // enableLinearization: true,
          })
        );
        resolve();
      }).catch(reject);
    });
  }
  registerEventsHandler(eventsHandler) {
    this.adobeDCView.registerCallback(
      this.window.AdobeDC.View.Enum.CallbackType.EVENT_LISTENER,
      (event) => {
        eventsHandler(event.type);
      },
      {}
    );
  }
}

var PDF_STATUS = /* @__PURE__ */ ((PDF_STATUS2) => {
  PDF_STATUS2[PDF_STATUS2["NONE"] = 0] = "NONE";
  PDF_STATUS2[PDF_STATUS2["PENDING"] = 1] = "PENDING";
  PDF_STATUS2[PDF_STATUS2["LOADING_FILE"] = 2] = "LOADING_FILE";
  PDF_STATUS2[PDF_STATUS2["READY"] = 3] = "READY";
  PDF_STATUS2[PDF_STATUS2["ERROR"] = 4] = "ERROR";
  return PDF_STATUS2;
})(PDF_STATUS || {});
const PDF_OPTIONS_TO_EMBED_PROPERTIES = {
  FULL: "",
  MINI: "SIZED_CONTAINER"
};
const PDF_OPTIONS = {
  FULL: "FULL",
  MINI: "MINI",
  NONE: "NONE"
};
const RICOS_LOCALE_TO_ADOBE = {
  da: "da-DK",
  nl: "nl-NL",
  en: "en-US",
  fi: "fi-FI",
  fr: "fr-FR",
  de: "de-DE",
  it: "it-IT",
  ja: "ja-JP",
  no: "nb-NO",
  pt: "pt-BR",
  es: "es-ES",
  sv: "sv-SE",
  cs: "cs-CZ",
  ko: "ko-KR",
  pl: "pl-PL",
  ru: "ru-RU",
  tr: "tr-TR",
  zh: "zg-CN"
};
const ADOBE_EVENT_TO_PDF_STATUS = {
  APP_RENDERING_DONE: 3 /* READY */,
  PDF_VIEWER_OPEN: 2 /* LOADING_FILE */,
  APP_RENDERING_FAILED: 4 /* ERROR */
};

var styles = {"iframe":"_5J2EK","not_ready":"L5hkI","pdf_viewer":"s0KmC"};

function setAdobeSDKScript(scope) {
  const element = scope.document.createElement("script");
  element.setAttribute("id", "ricos-adobe-pdf-view-sdk");
  element.setAttribute("src", "https://documentcloud.adobe.com/view-sdk/main.js");
  scope.document.getElementsByTagName("body")[0].appendChild(element);
}
function PDFViewer(props) {
  const {
    status,
    setStatus,
    fileData,
    config: { clientId, locale = "en" },
    pdfSettings
  } = props;
  const [divId, setDivId] = useState(void 0);
  if (!divId) {
    setDivId(`ricos-pdf-viewer-${Math.floor(Math.random() * 1e4)}`);
  }
  const {
    viewMode = PDF_OPTIONS.NONE,
    disableDownload = false,
    disablePrint = false
  } = pdfSettings || {};
  const handleError = (error) => {
    console.log(error);
    setStatus(PDF_STATUS.ERROR);
  };
  const eventsHandler = (event) => {
    const newStatus = ADOBE_EVENT_TO_PDF_STATUS[event];
    if (newStatus && newStatus !== status) {
      setStatus(newStatus);
    }
  };
  useEffect(() => {
    const pdfStatus = viewMode !== PDF_OPTIONS.NONE ? PDF_STATUS.PENDING : PDF_STATUS.NONE;
    status !== pdfStatus && setStatus(pdfStatus);
  }, [
    props.pdfSettings.viewMode,
    props.pdfSettings.disableDownload,
    props.pdfSettings.disablePrint
  ]);
  useEffect(() => {
    if (!window.document.getElementById("ricos-adobe-pdf-view-sdk")) {
      setAdobeSDKScript(window);
    } else if (status === PDF_STATUS.PENDING) {
      const SDKClient = new PDFViewSDKClient(window);
      SDKClient.ready().then(() => {
        const viewerConfig = {
          embedMode: PDF_OPTIONS_TO_EMBED_PROPERTIES[viewMode],
          showDownloadPDF: !disableDownload,
          showPrintPDF: !disablePrint
        };
        const properties = { clientId, divId, locale: RICOS_LOCALE_TO_ADOBE[locale] };
        SDKClient.previewFileWithURL(properties, fileData, viewerConfig).then(() => {
          SDKClient.registerEventsHandler(eventsHandler);
        }).catch(handleError);
      }).catch(handleError);
    }
  });
  const style = classnames(styles.pdf_viewer, { [styles.not_ready]: status !== PDF_STATUS.READY });
  return /* @__PURE__ */ React.createElement("div", { id: divId, className: style });
}

var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const getNameWithoutType = (fileName) => {
  if (!fileName || !fileName.includes(".")) {
    return fileName;
  }
  const s = fileName.split(".");
  return s.slice(0, s.length - 1).join(".");
};
const resizeWidths = { first: 320, second: 140, third: 100 };
class FileUploadViewer extends PureComponent {
  constructor(props) {
    super(props);
    __publicField(this, "isInResizeRange", (resizeWidth) => {
      var _a, _b;
      return ((_b = (_a = this.fileUploadViewerRef) == null ? void 0 : _a.current) == null ? void 0 : _b.clientWidth) < resizeWidth;
    });
    __publicField(this, "switchReadyIcon", () => {
      return this.setState(
        { showReadyIcon: true },
        () => setTimeout(() => this.setState({ showReadyIcon: false }), 2e3)
      );
    });
    __publicField(this, "renderContainerWithoutLink", () => {
      const { tempDataPlaceHolder, componentData } = this.props;
      const { name, type } = tempDataPlaceHolder ? tempDataPlaceHolder : componentData;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classnames(this.styles.file_upload_link, {
            [this.styles.width_three]: this.isInResizeRange(resizeWidths.third)
          })
        },
        this.renderViewerBody({ name, type })
      );
    });
    __publicField(this, "renderIcon", (Icon) => {
      const {
        isLoading,
        isMobile,
        componentData: { error }
      } = this.props;
      const { showReadyIcon, resolvingUrl, pdfStatus } = this.state;
      const showLoader = isLoading || resolvingUrl || pdfStatus === PDF_STATUS.LOADING_FILE;
      const showFileIcon = !showLoader && !showReadyIcon && isMobile || !isMobile && Icon;
      if (showFileIcon) {
        return /* @__PURE__ */ React.createElement(
          Icon,
          {
            styles: this.styles,
            className: classnames(this.styles.file_upload_type_icon, {
              [this.styles.width_three]: this.isInResizeRange(resizeWidths.third)
            })
          }
        );
      } else {
        return /* @__PURE__ */ React.createElement("div", { className: isMobile ? this.styles.mobile_status_icon : this.styles.file_upload_state }, error ? /* @__PURE__ */ React.createElement(ErrorIcon, null) : showLoader ? /* @__PURE__ */ React.createElement(LoaderIcon, { className: this.styles.file_loader_icon }) : showReadyIcon ? /* @__PURE__ */ React.createElement(ReadyIcon, null) : !this.isInResizeRange(resizeWidths.first) && /* @__PURE__ */ React.createElement(DownloadIcon, null));
      }
    });
    __publicField(this, "sizeToString", (size) => {
      return size < 1e3 ? size + "B" : size < 1e6 ? Math.round(size / 1e3) + "KB" : (size / 1e6).toFixed(2) + "MB";
    });
    __publicField(this, "getExperiments", () => this.props.experiments || this.context.experiments);
    __publicField(this, "onFileClick", () => {
      var _a, _b;
      return (_b = (_a = this.props.helpers).onViewerAction) == null ? void 0 : _b.call(_a, FILE_UPLOAD_TYPE, "Click");
    });
    __publicField(this, "onPDFStatusChange", (status) => this.setState({ pdfStatus: status }));
    const {
      componentData,
      componentData: { type, pdfSettings },
      settings: { adobeAPIKey }
    } = props;
    const viewMode = (pdfSettings == null ? void 0 : pdfSettings.viewMode) || PDF_OPTIONS.NONE;
    validate(componentData, pluginFileUploadSchema);
    this.downloaderRef = React.createRef();
    this.fileUploadViewerRef = React.createRef();
    const pdfStatus = type === "pdf" && viewMode !== PDF_OPTIONS.NONE && adobeAPIKey ? PDF_STATUS.PENDING : PDF_STATUS.NONE;
    this.state = {
      resolvedFileUrl: null,
      resolvingUrl: false,
      currentWidth: 0,
      pdfStatus
    };
  }
  componentWillReceiveProps(nextProps) {
    const {
      componentData: nextComponentData,
      settings: { adobeAPIKey }
    } = nextProps;
    const { componentData } = this.props;
    if (!isEqual(nextComponentData, componentData)) {
      validate(nextComponentData, pluginFileUploadSchema);
    }
    if (!nextProps.isLoading && this.props.isLoading) {
      this.switchReadyIcon();
    }
  }
  componentDidMount() {
    if (window == null ? void 0 : window.ResizeObserver) {
      this.resizer = new ResizeObserver(
        debounce((entries) => {
          this.setState({ currentWidth: Math.round(entries[0].contentRect.width) });
        }, 60)
      );
      this.resizer.observe(this.fileUploadViewerRef.current);
    }
  }
  componentWillUnmount() {
    var _a;
    (_a = this.resizeObserver) == null ? void 0 : _a.unobserve(this.fileUploadViewerRef.current);
  }
  getFileInfoString(type) {
    const { componentData, t, isLoading, tempDataPlaceHolder } = this.props;
    const { resolvingUrl } = this.state;
    if (componentData.error) {
      return {
        infoString: t("UploadFile_Error_Generic_Item"),
        infoStyle: this.styles.file_upload_text_error
      };
    }
    const translationKey = isLoading || resolvingUrl ? "UploadFile_Viewer_Loader" : "UploadFile_Viewer_Download";
    let infoString = t(translationKey, {
      fileType: type == null ? void 0 : type.toUpperCase()
    });
    const size = componentData.size || (tempDataPlaceHolder == null ? void 0 : tempDataPlaceHolder.size);
    if (size) {
      infoString = infoString + " \u2022 " + this.sizeToString(size);
    }
    return { infoString, infoStyle: this.styles.file_upload_type };
  }
  renderViewerBody({ name, type }) {
    const { isMobile } = this.props;
    const nameWithoutType = getNameWithoutType(name);
    const Icon = getIcon(type);
    const { infoString, infoStyle } = this.getFileInfoString(type);
    return /* @__PURE__ */ React.createElement(React.Fragment, null, this.renderIcon(Icon), !isMobile && this.renderIcon(), !this.isInResizeRange(resizeWidths.third) && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classnames(this.styles.file_upload_text_container, {
          [this.styles.width_two]: this.isInResizeRange(resizeWidths.second)
        })
      },
      /* @__PURE__ */ React.createElement("div", { className: this.styles.file_upload_name_container }, !this.isInResizeRange(resizeWidths.second) && /* @__PURE__ */ React.createElement("div", { className: this.styles.file_upload_name }, nameWithoutType), type && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classnames(this.styles.file_upload_extension, {
            [this.styles.width_one]: this.isInResizeRange(resizeWidths.first)
          })
        },
        "." + type
      )),
      /* @__PURE__ */ React.createElement("div", { className: infoStyle }, infoString)
    ));
  }
  renderViewer(fileUrl) {
    const {
      componentData: { name, type, error },
      tempDataPlaceHolder
    } = this.props;
    const { downloadTarget } = this.props.settings;
    if (error || tempDataPlaceHolder) {
      return this.renderContainerWithoutLink();
    }
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        href: fileUrl,
        target: downloadTarget,
        className: classnames(this.styles.file_upload_link, {
          [this.styles.width_three]: this.isInResizeRange(resizeWidths.third)
        }),
        onClick: this.onFileClick
      },
      this.renderViewerBody({ name, type })
    );
  }
  renderFileUrlResolver() {
    const {
      componentData,
      settings: { resolveFileUrl }
    } = this.props;
    const { name, type, error } = componentData;
    if (error) {
      return this.renderContainerWithoutLink();
    }
    const fileUrlResolver = () => {
      const { resolvingUrl } = this.state;
      if (!resolvingUrl) {
        this.setState({ resolvingUrl: true });
        resolveFileUrl(componentData).then((resolvedFileUrl) => {
          this.setState({ resolvedFileUrl, resolvingUrl: false }, this.switchReadyIcon);
          if (this.downloaderRef.current) {
            this.downloaderRef.current.href = resolvedFileUrl;
            this.downloaderRef.current.download = name;
            this.downloaderRef.current.click();
          }
        });
      }
    };
    const resolveIfEnter = (ev) => {
      const enterEvent = 13;
      if (ev.which === enterEvent) {
        fileUrlResolver();
      }
    };
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        onClick: fileUrlResolver,
        onKeyDown: resolveIfEnter,
        role: "button",
        tabIndex: 0,
        className: classnames(this.styles.file_upload_link, {
          [this.styles.width_three]: this.isInResizeRange(resizeWidths.third)
        })
      },
      this.renderViewerBody({ name, type })
    );
  }
  renderAutoDownloadLinkRef() {
    const {
      settings: { resolveFileUrl: withFileUrlResolver, downloadTarget }
    } = this.props;
    if (!withFileUrlResolver) {
      return null;
    }
    const target = downloadTarget || "_blank";
    this.getExperiments();
    return /* @__PURE__ */ React.createElement("a", { href: "#0", ref: this.downloaderRef, style: { display: "none" }, target }, /* @__PURE__ */ React.createElement(React.Fragment, null));
  }
  render() {
    var _a;
    const {
      componentData,
      componentData: { pdfSettings = {} },
      theme,
      setComponentUrl,
      tempDataPlaceHolder,
      settings: { adobeAPIKey },
      locale,
      iframeSandboxDomain
    } = this.props;
    const { pdfStatus } = this.state;
    this.styles = this.styles || mergeStyles({ styles: styles$1, theme });
    const fileUrl = componentData.url || this.state.resolvedFileUrl;
    setComponentUrl == null ? void 0 : setComponentUrl(fileUrl);
    const viewer = fileUrl || tempDataPlaceHolder ? this.renderViewer(fileUrl) : this.renderFileUrlResolver();
    const dataHook = "fileUploadViewer";
    const shouldRenderPDFViewer = ((_a = this.getExperiments().enableFilePluginPDFViewer) == null ? void 0 : _a.enabled) && typeof window !== "undefined" && fileUrl && ![PDF_STATUS.ERROR].includes(pdfStatus);
    const style = classnames(
      this.styles.file_upload_container,
      componentData.error && this.styles.file_upload_error_container
    );
    return /* @__PURE__ */ React.createElement(
      Tooltip,
      {
        content: this.isInResizeRange(resizeWidths.first) && componentData.name,
        tooltipOffset: { y: 25 }
      },
      shouldRenderPDFViewer ? /* @__PURE__ */ React.createElement("div", { "data-hook": dataHook, ref: this.fileUploadViewerRef }, /* @__PURE__ */ React.createElement(
        PDFViewer,
        {
          status: pdfStatus,
          fileData: { url: fileUrl, fileName: componentData.name },
          setStatus: this.onPDFStatusChange,
          pdfSettings,
          config: {
            clientId: adobeAPIKey,
            locale
          }
        }
      ), ![PDF_STATUS.READY].includes(pdfStatus) && /* @__PURE__ */ React.createElement("div", { className: style }, viewer)) : /* @__PURE__ */ React.createElement("div", { "data-hook": dataHook, ref: this.fileUploadViewerRef, className: style }, viewer, this.renderAutoDownloadLinkRef())
    );
  }
}
__publicField(FileUploadViewer, "contextType", GlobalContext);
FileUploadViewer.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  componentData: PropTypes.object.isRequired,
  tempDataPlaceHolder: PropTypes.object,
  settings: PropTypes.object,
  theme: PropTypes.object.isRequired,
  setComponentUrl: PropTypes.func,
  t: PropTypes.func,
  isMobile: PropTypes.bool,
  helpers: PropTypes.object,
  locale: PropTypes.string,
  iframeSandboxDomain: PropTypes.string,
  experiments: PropTypes.object
};
FileUploadViewer.defaultProps = {
  isLoading: false,
  settings: {}
};
var FileUploadViewer$1 = FileUploadViewer;

const typeMapper = () => ({
  [FILE_UPLOAD_TYPE]: {
    component: FileUploadViewer$1
  }
});

const DEFAULTS = {
  config: { alignment: "center", size: "content" },
  configViewer: {
    downloadTarget: "_blank"
  }
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginFileUpload = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.configViewer), config),
    type: FILE_UPLOAD_TYPE,
    typeMapper
    // nodeViewRenderers,
  };
};

export { FILE_UPLOAD_TYPE, typeMapper as fileUploadTypeMapper, pluginFileUpload };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-file-upload/dist/es/styles.viewer.min.global.css'